import type { GameState } from '../../core/types';

interface GameHeaderProps {
  state: GameState;
  eyebrow?: string;
}

export function GameHeader({ state, eyebrow }: GameHeaderProps) {
  const run = state.run;

  return (
    <header className="game-header">
      <div className="brand-lockup" aria-label="Cathedris">
        <span className="brand-mark" aria-hidden="true"><i /></span>
          <span>
            <span className="brand-name">Cathedris</span>
            <span className="brand-subtitle">The Bellrose Line</span>
          </span>
      </div>
      {run ? (
        <dl className="run-strip" aria-label="Expedition status">
          <div className="run-strip__portrait">
            <dt>Mechanic</dt>
            <dd><img src="/art/cathedris/characters/protagonist.webp" alt="" /></dd>
          </div>
          <div>
            <dt>Act</dt>
            <dd>{run.act}</dd>
          </div>
          <div>
            <dt>Depth</dt>
            <dd>{run.node + 1}</dd>
          </div>
          <div>
            <dt>Iron</dt>
            <dd>{run.iron}</dd>
          </div>
          {eyebrow ? (
            <div className="run-strip__wide">
              <dt>Location</dt>
              <dd>{eyebrow}</dd>
            </div>
          ) : null}
        </dl>
      ) : null}
    </header>
  );
}
